import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {LayoutService} from '../../../../core';
import {SubheaderService} from '../_services/subheader.service';
import {BreadcrumbItemModel} from '../_models/breadcrumb-item.model';
import {FormControl} from '@angular/forms';
import {WorkTrackerService} from '../../../../../modules/work-tracker/_services/work-tracker-service';
import {UsersService} from '../../../../../modules/auth/_services/users.service';
import {Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {StompService} from '../../../../../_upsell/shared/services/stomp.service';
import {CurrentUserDataService} from "../../../../../shared/_services/current-user-data.service";
import { FontAccessibilityService } from '../../../../../shared/_services/font-accessibility.service';

@Component({
    selector: 'app-subheader1',
    templateUrl: './subheader1.component.html',
    styleUrls: ['./subheader1.component.scss']
})
export class Subheader1Component implements OnInit {
    subheaderCSSClasses = '';
    subheaderContainerCSSClasses = '';
    subheaderMobileToggle = false;
    subheaderDisplayDesc = false;
    subheaderDisplayDateRangePicker = false;
    title$: Observable<string>;
    breadcrumbs$: Observable<BreadcrumbItemModel[]>;
    breadcrumbs: BreadcrumbItemModel[] = [];
    description$: Observable<string>;
    @Input() title: string;
    actualDate;

    // Form Input
    workFromHome = new FormControl(false);

    // User
    userRolls = [];

    // Track Work
    workTrackerObject: any;
    workShifts: any = [];
    lastWorkShiftEntry: any;
    startWorkingDate: any;
    workShiftEnded: boolean;

    // Work Tracker Toggle
    showWorkTracker = false;

    constructor(
        private layout: LayoutService,
        private subheader: SubheaderService,
        private cdr: ChangeDetectorRef,
        private workTrackerService: WorkTrackerService,
        private userService: UsersService,
        private router: Router,
        private modalService: NgbModal,
        private stompService: StompService,
        public currentUserData: CurrentUserDataService,
        public styling: FontAccessibilityService
    ) {
        this.title$ = this.subheader.titleSubject.asObservable();
    }

    ngOnInit() {

        this.userData();
        this.realTimeUpdate();

        this.title$ = this.subheader.titleSubject.asObservable();
        this.breadcrumbs$ = this.subheader.breadCrumbsSubject.asObservable();
        this.description$ = this.subheader.descriptionSubject.asObservable();
        this.subheaderCSSClasses = this.layout.getStringCSSClasses('subheader');
        this.subheaderContainerCSSClasses = this.layout.getStringCSSClasses(
            'subheader_container'
        );
        this.subheaderMobileToggle = this.layout.getProp('subheader.mobileToggle');
        this.subheaderDisplayDesc = this.layout.getProp('subheader.displayDesc');
        this.subheaderDisplayDateRangePicker = this.layout.getProp(
            'subheader.displayDaterangepicker'
        );
        this.breadcrumbs$.subscribe((res) => {
            this.breadcrumbs = res;
            this.cdr.detectChanges();
        });


        this.checkWorkShift();

        this.subscribeToSocket();

    }


    // Get User Data
    userData() {
        this.currentUserData.getCurrentUserData().subscribe(data => {
            this.userRolls = data.roles;
        });
    }

    checkWorkShift() {
        this.workTrackerService.getCurrentUserWorkTrackers().subscribe((workTracks: any) => {
            this.workShifts = workTracks;
            if (this.workShifts.length > 0) {
                this.lastWorkShiftEntry = this.workShifts[this.workShifts.length - 1];
                this.startWorkingDate = this.lastWorkShiftEntry.startDate;
                // console.log('startWorkingDate: ',this.startWorkingDate);
                // console.log('lastWorkShiftEntry: ',this.lastWorkShiftEntry);

                if (this.lastWorkShiftEntry.endDate === null) {
                    this.workShiftEnded = false;
                } else {
                    this.workShiftEnded = true;
                }
            } else {
                 this.workShiftEnded = true;
            }
        });
    }


    startWork() {
        this.userService.getCurrentUser().subscribe(() => {

            this.workTrackerObject = {
                workFromHome: this.workFromHome.value
            };

            this.userService.createWorkTracker(this.workTrackerObject).subscribe(() => {
                this.checkWorkShift();
            }, error => {
                
            });
        }, error => {
            alert('Session expired! You will be redirected to the login page.');
            this.router.navigate(['/auth/login']);
        });
    }

    endWork() {
        this.userService.getCurrentUser().subscribe(() => {
            this.userService.endWorkTracker().subscribe(() => {
                this.checkWorkShift();
            });

        }, error => {
            alert('Session expired! You will be redirected to the login page.');
            this.router.navigate(['/auth/login']);
        });
    }


    workConfirmModal(modal) {
        this.modalService.open(modal, {centered: true});
    }

    subscribeToSocket() {
        this.stompService.subscribe('/topic/workTracker', (): void => {
            this.checkWorkShift();
        });
    }

    // Real Time Update
    realTimeUpdate() {
        this.actualDate = Date();
        setTimeout(() => {
            this.realTimeUpdate();
        }, 500);
    }

    // Toggle Work Tracker
    showWorkTrackerTest() {
        this.showWorkTracker = !this.showWorkTracker;
    }
}
